import { call, put, take, fork } from 'redux-saga/effects';
import { eventChannel, END } from 'redux-saga';
import axios from './axiosHandler';
import { API_HOST } from '../env';
import sagaLoading from './sagaLoading';
// eslint-disable-next-line
import {
  MESSAGE_ERROR,
  MESSAGE_SUCCESS,
  UPLOAD_SINGLE_SUCCESS,
  UPLOAD_PROGRESS,
} from '../actions/actionTypes';

function upload(payload, onProgress) {
  const url = `${API_HOST}content/createSingle`;
  const singleData = new FormData();
  Object.keys(payload).map((item) => {
    if (item === 'audio' || item === 'video' || item === 'thumbnail') {
      singleData.append(item, payload[item]);
    } else if (item === 'tags') {
      singleData.set(item, payload[item].join());
    } else {
      singleData.set(item, payload[item]);
    }
    return null;
  });

  const config = {
    onUploadProgress: onProgress,
  };

  return axios({
    url,
    method: 'post',
    data: singleData,
    config,
  });
}

function createUploader(payload) {
  let emit;
  const chan = eventChannel((emitter) => {
    emit = emitter;
    return () => {};
  });

  const uploadPromise = upload(payload.data, (event) => {
    if (event.loaded === event.total) {
      emit(0);
      emit(END);
    }
    emit(Math.round((event.loaded * 100) / event.total));
  });

  return [uploadPromise, chan];
}

function* watchOnProgress(chan) {
  while (true) {
    const data = yield take(chan);
    yield put({ type: 'UPLOAD_PROGRESS', payload: data });
  }
}

export default function* sagaUploadSingle(data) {
  console.log('sagaUploadSingle ==> ', data);
  const [uploadPromise, chan] = createUploader(data);
  yield fork(watchOnProgress, chan);
  try {
    yield call(sagaLoading, true);
    const resData = yield call(() => uploadPromise);
    yield put({ type: UPLOAD_SINGLE_SUCCESS, payload: new Date() });
    yield put({ type: MESSAGE_SUCCESS, payload: resData.data.message });
    yield call(sagaLoading, false);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('err ===> ', error);
    // console.log(error);
    yield call(sagaLoading, false);
    yield put({
      type: MESSAGE_ERROR,
      payload: error.message ? error.message : 'There is something wrong, please, try again.',
    });
  }
}
